// @flow
import React from 'react';
import {
  types as t,
  usePropsValidation,
} from '../../validation/runtime-checks/index.js';

export function RSLEmphasis(props: {| children: string |}) {
  const { failedValidation } = usePropsValidation(props, RSLEmphasis);

  if (failedValidation) return null;

  return <em style={{ fontStyle: 'italic' }}>{props.children}</em>;
}

RSLEmphasis.spec = {
  children: t.string,
};
